



















































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import store from '../store'
import axios from 'axios'
import ImageUploadVue from '@/components/ImageUpload.vue'
import { deepCopy } from '@/components/deepCopy'
import * as CategoryAPI from '@/api/categories'
import snackbar from '@/components/snackbar.vue'

interface Category {
  id: number
  visible: boolean
  children: Category[]
  name: string
  image: string | null
  preview?: any
  file?: any
  itemCount: number
  //sortorder: number
}

interface UploadChanges {
  relations: {
    categoryId: number
    childrenId: number[]
  }[]
  categoryChanges: {
    id: number
    name: string
    visible: boolean
    // TODO: preview upload image
    //sortorder: number
    image?: any
    top: boolean // is top level category
  }[]
  removed: number[] // removed categories
}
@Component({
  name: 'Settings',
  components: { imageReplace: ImageUploadVue, snackbar }
})
export default class extends Vue {
  unsavedIdCounter = 0
  removedCategories: number[]
  isLoading = false
  created() {
    this.isLoading = true
    this.fetchCategories().then(() => {
      this.isLoading = false
    })
    this.removedCategories = []
  }
  addTopLevelCategory() {
    const newCategory = this.unsavedCategory(this.categories.length)
    this.categories.push(newCategory)
  }
  addSubCategory() {
    const newCategory = this.unsavedCategory(this.selected.children.length)
    this.selected.children.push(newCategory)
  }

  private unsavedCategory(sortOrder: number): Category {
    this.unsavedIdCounter--
    return {
      id: this.unsavedIdCounter,
      visible: true,
      children: [],
      name: 'Neue Kategorie',
      image: null,
      itemCount: 0,
      //sortorder: sortOrder,
      preview: null
    }
  }
  async deleteCategory(id: number) {
    this.deleteCategoryById(this.categories, id)
  }
  reverseChanges() {
    this.unsavedIdCounter = 0
    this.removedCategories = []
    this.categories = deepCopy(this.categoriesUnmodified)
  }
  private getPreviewImages(category: Category): any[] {
    let previews = []
    if (category.preview != null) {
      console.log('preview found')
      console.log(category.file.name)
      previews.push({ file: category.file, name: category.file.name })
    }
    category.children.forEach(child => {
      const chElems = this.getPreviewImages(child)
      previews = previews.concat(chElems)
    })
    return previews
  }
  uploadChanges() {
    // check each category
    let changes: UploadChanges = {
      relations: [],
      categoryChanges: [],
      removed: []
    }

    for (let index = 0; index < this.categories.length; index++) {
      const mainCategory = this.categories[index]

      changes = this.scanCategory(mainCategory, changes, true)
    }
    // submit removed category IDs
    if (this.removedCategories.length > 0) {
      changes.removed = changes.removed.concat(this.removedCategories)
    }

    // if modified, upload
    if (!(Object.keys(changes).length === 0 && changes.constructor === Object)) {
      // upload
      const formData = new FormData()

      let imageFiles: any[] = []
      for (let index = 0; index < this.categories.length; index++) {
        const mainCategory = this.categories[index]
        const c = this.getPreviewImages(mainCategory)
        imageFiles = imageFiles.concat(c)
      }
      if (imageFiles.length > 0) {
        Array.from(Array(imageFiles.length).keys()).map(x => {
          console.log(imageFiles[x].name)
          formData.append('images', imageFiles[x].file, imageFiles[x].name)
        })
      }
      formData.append('categoryChanges', JSON.stringify(changes.categoryChanges))
      if (changes.removed != undefined) formData.append('categoryRemoved', JSON.stringify(changes.removed))
      formData.append('categoryRelations', JSON.stringify(changes.relations))
      console.log(formData)
      this.upload(formData)
    }
  }

  private message = ''
  private snackbar = false
  private async upload(formData: any) {
    this.isLoading = true
    try {
      const { data } = await CategoryAPI.uploadCategoryChanges(formData)
      if (data && data.successful === true) {
        this.message = 'Kategorien erfolgreich aktualisiert.'
        this.snackbar = true
        this.unsavedIdCounter = 0
        this.removedCategories = []
        this.categories = []
        this.active = []
        await this.fetchCategories()
      } else {
        this.message = 'Fehler bei dem Versuch die Kategorien zu ändern: ' + data.errors.join('\r\n')
        this.snackbar = true
      }
      this.isLoading = false
    } catch (error) {
      console.log(error)
      this.message = 'Der Server ist aktuell nicht erreichbar. Fehlermeldung: ' + error
      this.snackbar = true
      this.isLoading = false
    }

    // const { data } = await uploadImages(this.formData)
  }

  private scanCategory(category: Category, dbChanges: UploadChanges, isTopLevelCategory: boolean): UploadChanges {
    console.log(category.name)
    if (category.id < 0) {
      // new category
      dbChanges.categoryChanges.push({
        id: category.id,
        name: category.name,
        visible: category.visible,
        //sortorder: category.sortorder,
        top: isTopLevelCategory,
        image: category.file != null ? category.file.name : category.image
      })
      // relations
      const categoryChildrenId = []
      for (let index = 0; index < category.children.length; index++) {
        const child = category.children[index].id
        categoryChildrenId.push(child)
      }
      dbChanges.relations.push({ categoryId: category.id, childrenId: categoryChildrenId })
    } else {
      // scan all unmodified categories and check if we have changes
      for (let index = 0; index < this.categoriesUnmodified.length; index++) {
        const element = this.categoriesUnmodified[index]
        // compare with original. if changes found, push them
        const unmodCategory = this.compareCategory(category, element)
        if (unmodCategory != null) {
          // check if we have changes
          if (
            unmodCategory.visible != category.visible ||
            unmodCategory.image != category.image ||
            unmodCategory.preview != category.preview ||
            //unmodCategory.sortorder != category.sortorder ||
            unmodCategory.name != category.name
          ) {
            // node has changed, update it
            // TODO image
            dbChanges.categoryChanges.push({
              id: category.id,
              name: category.name,
              visible: category.visible,
              //sortorder: category.sortorder,
              image: category.file != null ? category.file.name : category.image,
              top: isTopLevelCategory
            })
          }

          let childrenChangesFound = false
          if (category.children.length != unmodCategory.children.length) {
            childrenChangesFound = true
          } else {
            for (let index = 0; index < category.children.length; index++) {
              const child = category.children[index]
              const unModChild = unmodCategory.children[index]
              // check parent child relations
              // TODO
              if (child.id != unModChild.id) {
                childrenChangesFound = true
              }
            }
          }
          if (childrenChangesFound) {
            // submit whole child relations
            const categoryChildrenId = []
            for (let index = 0; index < category.children.length; index++) {
              const child = category.children[index].id
              categoryChildrenId.push(child)
            }
            dbChanges.relations.push({ categoryId: category.id, childrenId: categoryChildrenId })
          }
        } else {
          // unmodCategory can not be null if it's not a new category
          // TODO remove
          console.log('this should not happen')
        }
      }
      //no changes
      //return null
    }
    // do children
    for (let index = 0; index < category.children.length; index++) {
      const child = category.children[index]
      dbChanges = this.scanCategory(child, dbChanges, false)
    }
    return dbChanges
  }
  private compareCategory(potentiallyModified: Category, unmodified: Category): Category {
    if (potentiallyModified.id == unmodified.id) {
      return unmodified
    } else {
      // check subcategories
      for (let index = 0; index < unmodified.children.length; index++) {
        const element = unmodified.children[index]
        const unmodifiedSibling: Category = this.compareCategory(potentiallyModified, element)
        if (unmodifiedSibling != null) {
          return unmodifiedSibling
        }
      }
      return null
    }
  }
  async myfunction() {
    const answer = await axios.get(process.env.VUE_APP_BASE_URL + 'api/')
    console.log(answer)
  }

  avatars = [
    '?accessoriesType=Blank&avatarStyle=Circle&clotheColor=PastelGreen&clotheType=ShirtScoopNeck&eyeType=Wink&eyebrowType=UnibrowNatural&facialHairColor=Black&facialHairType=MoustacheMagnum&hairColor=Platinum&mouthType=Concerned&skinColor=Tanned&topType=Turban',
    '?accessoriesType=Sunglasses&avatarStyle=Circle&clotheColor=Gray02&clotheType=ShirtScoopNeck&eyeType=EyeRoll&eyebrowType=RaisedExcited&facialHairColor=Red&facialHairType=BeardMagestic&hairColor=Red&hatColor=White&mouthType=Twinkle&skinColor=DarkBrown&topType=LongHairBun',
    '?accessoriesType=Prescription02&avatarStyle=Circle&clotheColor=Black&clotheType=ShirtVNeck&eyeType=Surprised&eyebrowType=Angry&facialHairColor=Blonde&facialHairType=Blank&hairColor=Blonde&hatColor=PastelOrange&mouthType=Smile&skinColor=Black&topType=LongHairNotTooLong',
    '?accessoriesType=Round&avatarStyle=Circle&clotheColor=PastelOrange&clotheType=Overall&eyeType=Close&eyebrowType=AngryNatural&facialHairColor=Blonde&facialHairType=Blank&graphicType=Pizza&hairColor=Black&hatColor=PastelBlue&mouthType=Serious&skinColor=Light&topType=LongHairBigHair',
    '?accessoriesType=Kurt&avatarStyle=Circle&clotheColor=Gray01&clotheType=BlazerShirt&eyeType=Surprised&eyebrowType=Default&facialHairColor=Red&facialHairType=Blank&graphicType=Selena&hairColor=Red&hatColor=Blue02&mouthType=Twinkle&skinColor=Pale&topType=LongHairCurly'
  ]

  pause = ms => new Promise(resolve => setTimeout(resolve, ms))

  active = []
  avatar = null
  open = []
  categories: Category[] = []
  categoriesUnmodified: Category[] = []

  get items(): Category[] {
    return this.categories
  }
  findCategoryById(array, id: number) {
    let result
    array.some(o => (result = o.id === id ? o : this.findCategoryById(o.children || [], id)))
    return result
  }
  deleteCategoryById(array: Category[], id: number): boolean {
    for (let index = 0; index < array.length; index++) {
      const element = array[index]
      if (element.id == id) {
        this.removedCategories.push(id)
        array.splice(index, 1)
        return true
      } else {
        if (this.deleteCategoryById(element.children, id)) {
          return true
        }
      }
    }
    return false
  }
  get selected(): Category | null {
    //if (!this.active.length) return undefined
    const id = this.active[0]
    return this.findCategoryById(this.categories, id)
  }
  get selectedProductAmount() {
    function getChildrenItemCount(children: Category[]): number {
      let amount = 0
      children.forEach(child => {
        const childAmount = getChildrenItemCount(child.children)
        amount += childAmount + child.itemCount
      })
      return amount
    }
    if (this.selected != null) {
      const amount = this.selected.itemCount
      const childAmount = getChildrenItemCount(this.selected.children)
      return amount + childAmount
    } else {
      return null
    }
  }

  async fetchCategories() {
    // await this.pause(1500)
    const { data } = await CategoryAPI.getCategories()
    if (data) {
      const serverCategories = data
      console.log(data)
      for (let index = 0; index < data.length; index++) {
        const mainCategory = data[index]
        this.categories.push(mainCategory)
        this.categoriesUnmodified.push(deepCopy(mainCategory))
      }
    }

    // const exampleCategories = {
    //   id: 0,
    //   visible: true,
    //   itemCount: 200,
    //   children: [
    //     {
    //       id: 1,
    //       visible: true,
    //       children: [],
    //       name: 'sub1',
    //       image: null,
    //       sortorder: 0,
    //       itemCount: 100
    //     },
    //     {
    //       id: 2,
    //       visible: true,
    //       children: [],
    //       name: 'sub2',
    //       image: null,
    //       itemCount: 100,
    //       sortorder: 1
    //     }
    //   ],
    //   name: 'Main',
    //   image: null,
    //   sortorder: 0
    // }

    // return fetch('https://jsonplaceholder.typicode.com/users')
    //   .then(res => res.json())
    //   .then(json => item.children.push(...json))
    //   .catch(err => console.warn(err))
  }
  @Watch('selected')
  randomAvatar() {
    this.avatar = this.avatars[Math.floor(Math.random() * this.avatars.length)]
  }
}
